import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { MprcButton } from "components/MprcButton";
import { MprcLink } from "components/MprcLink";
import { MprcRequestError } from "components/MprcRequestErrorReport";
import { MprcRequestIndicator } from "components/MprcRequestIndicator";
import { GetCurrentAgreementQueryResponse } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import * as React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

export interface FileGetDto {
    fileId: string;
    url?: string;
    mimetype?: string;
    isEmbed?: boolean;
}

interface IProps {
    onClose: (agree: boolean) => void;
    onError?: (e: MprcRequestError) => void;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////

export const AgreementCheckbox: React.FC<Props> = (props) => {

    const [agreementData, setAgreementData] = useState<GetCurrentAgreementQueryResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const { onClose, onError } = props;

    const { t } = useTranslation();
    const api = useCoreApi();

    ///
    useEffect(() => {
        async function load() {
            try {
                var result = await api.v1.account.getCurrentAccessAgreement();
                setAgreementData(result.data);
            }
            catch (e: any) {
                onError && onError(e);
            }
            setLoading(false);
        }

        if (loading) load();
    }, [loading]);


    if (loading) {
        return <MprcRequestIndicator type="waiting" />;
    }

    if (agreementData == null) {
        onClose(true);
        return null;
    }

    return (
        <Dialog
            open
            fullWidth
            maxWidth="md"
        >
            <DialogContent sx={{ height: "100vh" }}>

                <Grid container alignItems="center" direction="column" height="100%" width="100%">
                    <Grid size="grow" width="100%" sx={{ border: "1px solid grey", padding: (theme) => theme.spacing(2) }}>
                        <div
                            style={{ height: "100%", width: "100%", overflowY: "auto" }}
                            dangerouslySetInnerHTML={{ __html: agreementData!.text }}
                        />
                    </Grid>

                    {
                        agreementData!.fileUrl &&
                        <Grid>
                            <MprcLink href={agreementData!.fileUrl} target="_blank">
                                <FontAwesomeIcon icon={faDownload} size="2x" />
                            </MprcLink>
                        </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <MprcButton variant="contained" color="cancel" onClick={() => onClose(false)}>
                    {t("Auth.AgreementCheckbox.IDisagree")}
                </MprcButton>
                <MprcButton variant="contained" color="success" onClick={() => onClose(true)}>
                    {t("Auth.AgreementCheckbox.IAgree")}
                </MprcButton>
            </DialogActions>
        </Dialog>
    );
};
